export default "__VITE_ASSET__DnqDrY66__"